import { makeStyles } from "tss-react/mui";
import { constants } from "../../constants";

export const useStyles = makeStyles()((theme) => ({
    root: {
        alignSelf: "center",
        width: "100%",
        height: "900px",
        display: "flex",
        flexDirection: "row",
        color: constants.color.black,
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        backgroundColor: constants.color.white,
        gap: "21px",
        paddingBottom: "50px",
    },
}));
